import React from 'react';
import type { Nullable } from 'corgi-types';

import type { GroupValueArticle } from '../../../product-mvc-buttons/components/types';
import DeliveryTimePeriod from '../DeliveryTimePeriod';
import ArticleSmallPrice, { RenderingStrategy } from '../Price/ArticleSmallPrice';
import { BodyRegularBR2 } from '../Typography';

interface GroupValueArticleDetailsProps {
  article: Nullable<GroupValueArticle>;
}

const GroupValueArticleDetails = ({ article }: GroupValueArticleDetailsProps) => {
  if (!article) {
    return null;
  }

  const { prices, delivery } = article;
  const energyClass = article?.energyClass
    ? { ...article.energyClass, isDrawerToggleEnabled: false }
    : null;

  return (
    <>
      {prices.regular && (
        <ArticleSmallPrice
          regularPrice={prices.regular}
          specialPrice={prices.special}
          rrpPrice={prices.rrp}
          measurement={prices.measurement}
          energyClass={energyClass}
          renderingStrategy={RenderingStrategy.Horizontal}
        />
      )}
      {!!delivery && (
        <BodyRegularBR2>
          <DeliveryTimePeriod {...delivery} />
        </BodyRegularBR2>
      )}
    </>
  );
};

export default GroupValueArticleDetails;
